// https://htmx.org/docs/#webpack
window.htmx = require('htmx.org');
